import { getField } from 'vuex-map-fields'

export default {
  stores: state => state.stores,
  getStoreName: state => storeId => {
    let storeRecord = state.stores.find((element) => { return element.id === storeId })
    return storeRecord ? storeRecord.name : 'Без склада'
  },
  getField
}
